import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './RequestPasswordReset.module.css';
import Logo from 'assets/images/logos/logo-dark-backgrounds.svg';
import Button from 'components/UI/Button/Button';
import Input from 'components/UI/Input/Input';
import { checkValidity, updateObject } from 'shared/utility';
import * as actions from 'store/actions';

class RequestPasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controls: {
        email: {
          elementType: 'input',
          elementConfig: {
            type: 'email',
            placeholder: 'Email Address',
          },
          value: '',
          validation: {
            required: true,
            isEmail: true,
            validationError: 'Please enter a valid email address',
          },
          valid: false,
          touched: false,
        },
      },
    };
  }

  componentDidUpdate(prevProps) {
    // If user successfully completes password reset request, clear form.
    if (this.props.passwordResetSuccess && !prevProps.passwordResetSuccess) {
      const updatedControls = updateObject(this.state.controls, {
        email: updateObject(this.state.controls.email, {
          value: '',
          valid: false,
          touched: false,
        }),
      });

      this.setState({ controls: updatedControls });
    }
  }

  inputChangedHandler = (event) => {
    const updatedControls = updateObject(this.state.controls, {
      email: updateObject(this.state.controls.email, {
        value: event.target.value,
        valid: checkValidity(event.target.value, this.state.controls.email.validation),
        touched: event.target.value === '' ? false : this.state.controls.email.touched,
      }),
    });

    this.setState({ controls: updatedControls });
  };

  focusedOutHandler = () => {
    const updatedControls = updateObject(this.state.controls, {
      email: updateObject(this.state.controls.email, {
        touched: true,
      }),
    });
    this.setState({ controls: updatedControls });
  };

  submitPasswordReset = () => {
    this.props.onRequestPasswordReset(this.state.controls.email.value);
  };

  returnToSignIn = () => {
    this.props.history.push({ pathname: '/sign-in' });
  };

  render = () => {
    let submitReturnMessage = null;

    if (this.props.passwordResetError || this.props.passwordResetSuccess) {
      submitReturnMessage = (
        <p
          className={
            this.props.passwordResetError
              ? [classes.SubmitReturnMessage, classes.Error].join(' ')
              : [classes.SubmitReturnMessage, classes.Success].join(' ')
          }
        >
          {this.props.passwordResetError ? this.props.passwordResetError.replace(/_/g, ' ') : this.props.passwordResetSuccess.replace(/_/g, ' ')}
        </p>
      );
    }
    return (
      <div
        className={
          this.props.passwordResetSuccess ? [classes.RequestPasswordResetContainer, classes.Success].join(' ') : classes.RequestPasswordResetContainer
        }
      >
        <div className={classes.AuthLogo}>
          <img src={Logo} alt="riza" />
        </div>
        {this.props.passwordResetSuccess ? (
          <div className={classes.PasswordResetSent}>
            <h3>An email has been sent with a link to reset your password.</h3>
            <p onClick={this.props.onReturnToPasswordResetRequest} className={classes.ResendLink}>
              Resend Link
            </p>
          </div>
        ) : (
          <div>
            <div className={classes.Intro}>
              <h3>Forgot Your Password?</h3>
              <p>Enter your email and we'll send you a link to get back into your account.</p>
            </div>
            <div className={classes.RequestPasswordResetForm}>
              {submitReturnMessage}
              <Input
                value={this.state.controls.email.value}
                elementType={this.state.controls.email.elementType}
                elementConfig={this.state.controls.email.elementConfig}
                invalid={!this.state.controls.email.valid && this.state.controls.email.touched}
                touched={this.state.controls.email.touched}
                inputClassName="AuthInput"
                shouldValidate={this.state.controls.email.validation !== null}
                validationError={this.state.controls.email.validation ? this.state.controls.email.validation.validationError : null}
                placeholder={this.state.controls.email.elementConfig.placeholder}
                changed={(event) => this.inputChangedHandler(event)}
                blurred={(e) => this.focusedOutHandler(e)}
              />
              <div className={classes.ButtonContainer}>
                <Button btnType="Success" disabled={!this.state.controls.email.valid} clicked={this.submitPasswordReset}>
                  Send Link to Reset Password
                </Button>
              </div>
            </div>
            <p className={classes.ReturnToSignIn} onClick={this.returnToSignIn}>
              Back to Sign In
            </p>
          </div>
        )}
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    passwordResetError: state.auth.passwordResetError,
    passwordResetSuccess: state.auth.passwordResetSuccess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRequestPasswordReset: (Email) => dispatch(actions.requestPasswordReset(Email)),
    onReturnToPasswordResetRequest: () => dispatch(actions.returnToPasswordResetRequest()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestPasswordReset);
